import { useMapElement } from '../contextProviders/MapElementProvider';
import AgentConfiguration from './AgentConfiguration';
import OutcomeDetails from '../common/OutcomeDetails';
import screens from '../common/screens';

const AgentRouter = () => {
    const {
        currentScreen,
        mapElement,
        onSwitchScreen,
        selectedOutcomeIndex,
        setSelectedOutcomeIndex,
    } = useMapElement();

    switch (currentScreen) {
        case screens.agent:
            return <AgentConfiguration />;

        case screens.outcome: {
            const selectedOutcome = mapElement.outcomes?.[selectedOutcomeIndex ?? 0] ?? null;

            return (
                <OutcomeDetails
                    outcome={selectedOutcome}
                    onSave={() => onSwitchScreen(screens.agent)}
                    onCancel={() => {
                        onSwitchScreen(screens.agent);
                        setSelectedOutcomeIndex(null);
                    }}
                />
            );
        }
        default:
            return null;
    }
};

export default AgentRouter;
